import React, { useState } from "react";
import "../styles/events.css";
import SeoHead from "../components/SeoHead";

/* ──────────────────────────────────────────────────────────
   SECTION 1 — Conference & Event Photos
   Titles and subtitles drawn from the content visible on each
   conference banner / podium signage in the photos.
   ────────────────────────────────────────────────────────── */
const CONFERENCES = [
  {
    src: "/images/Event1.jpeg",
    title: "ISSHCON 2024, Bengaluru",
    subtitle:
      "47th Annual Conference of the Indian Society for Surgery of the Hand — combined meeting with Australia, Emirates & Singapore · 4–6 October 2024",
  },
  {
    src: "/images/Event2.jpeg",
    title: "4th Preethi Trauma Update, Madurai",
    subtitle:
      "Upper Extremity Trauma and Reconstructive Course · Preethi Hospitals",
  },
  {
    src: "/images/Event3.jpeg",
    title: "Hand Surgery Cadaveric Workshop",
    subtitle:
      "Hands-on instrumentation training · Medicover Institute, Hyderabad",
  },
  {
    src: "/images/Event4.jpeg",
    title: "TOSACON 2025, Hyderabad",
    subtitle:
      "10th Annual Conference of the Telangana Orthopaedic Surgeons Association",
  },
  {
    src: "/images/Event5.jpeg",
    title: "TOSACON 2024, Karimnagar",
    subtitle:
      "9th Annual Conference of the Telangana Orthopaedic Surgeons Association · 1–4 February 2024, V Convention",
  },
  {
    src: "/images/Event6.jpeg",
    title: "APFSSH–APFSHT–APWA–ISSH–SHTI Congress 2025",
    subtitle:
      "Free paper: Outcome assessment of complications in 147 hemi-hamate arthroplasties for PIP joint injuries · Westin Mumbai Powai Lake, 10–13 September 2025",
  },
  {
    src: "/images/Event7.jpeg",
    title: "AIG Hand & Microsurgery Meet",
    subtitle:
      "Academic Indian Orthopaedic Society session · AIG Hospitals",
  },
  {
    src: "/images/Event8.jpeg",
    title: "OASISCON — 21st Annual Conference",
    subtitle:
      "Orthopaedic Association of South Indian States · Presentation on scaphoid fracture management",
  },
  {
    src: "/images/Event9.jpeg",
    title: "TOSACON 2023, Hyderabad",
    subtitle:
      "8th Annual Conference of the Telangana Orthopaedic Surgeons Association · TFCC and wrist imaging session · 10–12 March 2023, HICC Novotel",
  },
  {
    src: "/images/Event10.jpeg",
    title: "APFSSH 2025 — International Faculty",
    subtitle:
      "Asia-Pacific Hand Surgery & Therapy Congress 2025, Mumbai · Delegates from across the region",
  },
  {
    src: "/images/Event11.jpeg",
    title: "55th OSSAPCON 2026, Kurnool",
    subtitle:
      "Annual Conference of the Orthopaedic Surgeons Society of Andhra Pradesh · 20–22 February 2026, Kurnool Medical College",
  },
  {
    src: "/images/Event12.jpeg",
    title: "TOSACON 2022, Warangal",
    subtitle:
      "7th Annual State Conference of the Telangana Orthopaedic Surgeons Association · 1–3 July 2022, NRI Alumni Hall, Kakatiya Medical College",
  },
];

const ARTICLES = [
  { src: "/images/Article1.jpeg" },
  { src: "/images/Article2.jpeg" },
  { src: "/images/Article3.jpeg" },
  { src: "/images/Article4.jpeg" },
  { src: "/images/Article5.jpeg" },
  { src: "/images/Article6.jpeg" },
];

export default function EventsArticles() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <div className="ea-page">

      <SeoHead
        title="Events & Articles — Hand & Wrist Clinics"
        description="News, conference appearances, workshops and press coverage featuring Dr. R. Suneel and Hand & Wrist Clinics."
        keywords="hand surgery articles Hyderabad, hand surgery blog, wrist surgery articles, hand injury awareness, patient education hand surgery, hand and wrist health articles, peripheral nerve surgery articles, brachial plexus treatment articles, orthopaedic articles Hyderabad, hand surgeon blog Hyderabad, Dr R Suneel articles, hand and wrist clinics Hyderabad"
        url="https://www.handandwristclinics.com/events-articles"
      />

      {/* HERO + BREADCRUMB */}
      <header className="ea-hero">
        <div className="ea-hero-inner">
          <nav className="ea-breadcrumb" aria-label="Breadcrumb">
            <a href="/">Home</a>
            <span className="ea-bc-sep">/</span>
            <span className="ea-bc-current">Events & Articles</span>
          </nav>
          <div className="ea-eyebrow">
            <span></span> News, Events & Press
          </div>
          <h1 className="ea-title">Events &amp; <em>Articles</em></h1>
          <div className="ea-divider" />
          <p className="ea-hero-sub">
            Newspaper features, media coverage, and event photographs from our
            workshops, awareness drives, and clinical work.
          </p>
        </div>
      </header>

      {/* SECTION 1 — CONFERENCES */}
      <section className="ea-section">
        <div className="ea-container">
          <div className="ea-section-head">
            <div className="ea-section-eyebrow">
              <span></span> Section 1
            </div>
            <h2 className="ea-section-title">
              Conference &amp; <em>Event Photos</em>
            </h2>
            <div className="ea-divider ea-divider-center" />
            <p className="ea-section-sub">
              Highlights from medical conferences, workshops, and society events.
            </p>
          </div>

          <div className="ea-conf-grid">
            {CONFERENCES.map((c, i) => (
              <article
                key={i}
                className="ea-conf-card"
                onClick={() => setLightbox(c)}
              >
                <div className="ea-conf-media">
                  <img src={c.src} alt={c.title} loading="lazy" />
                  <div className="ea-conf-overlay">
                    <span className="ea-zoom-icon" aria-hidden>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="11" cy="11" r="8" />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        <line x1="11" y1="8" x2="11" y2="14" />
                        <line x1="8"  y1="11" x2="14" y2="11" />
                      </svg>
                    </span>
                  </div>
                </div>
                <div className="ea-conf-body">
                  <h3 className="ea-conf-title">{c.title}</h3>
                  <p className="ea-conf-subtitle">{c.subtitle}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 2 — MEDIA COVERAGE */}
      <section className="ea-section ea-section-alt">
        <div className="ea-container">
          <div className="ea-section-head">
            <div className="ea-section-eyebrow">
              <span></span> Section 2
            </div>
            <h2 className="ea-section-title">
              Media Coverage &amp; <em>Articles</em>
            </h2>
            <div className="ea-divider ea-divider-center" />
            <p className="ea-section-sub">
              Newspaper features and press articles from regional and national publications.
            </p>
          </div>

          <div className="ea-strip">
            {ARTICLES.map((img, i) => (
              <figure
                key={i}
                className="ea-strip-item"
                onClick={() => setLightbox(img)}
              >
                <img src={img.src} alt={`Press article image ${i + 1}`} loading="lazy" />
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* LIGHTBOX */}
      {lightbox && (
        <div className="ea-lightbox" onClick={() => setLightbox(null)}>
          <button
            className="ea-lb-close"
            onClick={(e) => { e.stopPropagation(); setLightbox(null); }}
            aria-label="Close"
          >
            ✕
          </button>
          <img
            className="ea-lb-img"
            src={lightbox.src}
            alt={lightbox.title || "Hand and Wrist Clinics article image"}
            onClick={(e) => e.stopPropagation()}
          />
          {(lightbox.title || lightbox.subtitle) && (
            <div className="ea-lb-caption" onClick={(e) => e.stopPropagation()}>
              {lightbox.title && <h4>{lightbox.title}</h4>}
              {lightbox.subtitle && <p>{lightbox.subtitle}</p>}
            </div>
          )}
        </div>
      )}

    </div>
  );
}